import { useOrganisationLogo } from "@/api/queries";
import { useObjectUrl } from "@/lib/useObjectUrl";

import s from "./ui.module.css";

/**
 * An organisation's own logo on a white plate (logos are drawn for a light page, so the
 * plate keeps them readable in dark mode too), at most `height` pixels tall and keeping its
 * shape. Nothing is shown while it loads or when there is none. `src` shows a chosen file
 * instead, as a preview before it is saved. The alt names the organisation, unless `name`
 * is beside it already (`decorative`).
 */
export function OrganisationLogo({ name, version, src, height = 32, decorative = false }: { name: string; version?: string; src?: string; height?: number; decorative?: boolean }) {
  const logo = useOrganisationLogo(src ? undefined : version);
  const fetched = useObjectUrl(logo.data);
  const url = src ?? fetched;
  if (!url) return null;
  return (
    <span className={s.orgLogo} style={{ height: height + 8 }} data-logo={version}>
      <img src={url} alt={decorative ? "" : `${name} logo`} style={{ maxHeight: height }} />
    </span>
  );
}
